"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryingClient = void 0;

var _queryRequest = require("./query-request");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * A client which performs entity state queries.
 *
 * @abstract
 */
var QueryingClient = /*#__PURE__*/function () {
  /**
   * @param {!ActorRequestFactory} actorRequestFactory
   *        a request factory to build requests to Spine server
   */
  function QueryingClient(actorRequestFactory) {
    _classCallCheck(this, QueryingClient);

    this._requestFactory = actorRequestFactory;
  }
  /**
   * Creates a new query request.
   *
   * @param {!Class<Message>} entityType the target entity type
   * @param {!Client} client the client which initiated the request
   * @return {QueryRequest} a new query request
   */


  _createClass(QueryingClient, [{
    key: "select",
    value: function select(entityType, client) {
      return new _queryRequest.QueryRequest(entityType, client, this._requestFactory);
    }
    /**
     * Executes the given `Query` instance specifying the data to be retrieved from
     * Spine server fulfilling a returned promise with an array of received objects.
     *
     * @param {!spine.client.Query} query a query instance to be executed
     * @return {Promise<Message[]>} a promise to be fulfilled with a list of Protobuf
     *        messages of a given type or with an empty list if no entities matching given query
     *        were found; rejected with a `SpineError` if error occurs
     *
     * @template <T> a Protobuf type of entities being the target of a query
     */

  }, {
    key: "read",
    value: function read(query) {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * Creates a new query factory instance which can be further used for the `Query` creation.
     *
     * @return {QueryFactory}
     */

  }, {
    key: "newQuery",
    value: function newQuery() {
      return this._requestFactory.query();
    }
  }]);

  return QueryingClient;
}();

exports.QueryingClient = QueryingClient;
//# sourceMappingURL=querying-client.js.map